import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pie-charts',
  templateUrl: './pie-charts.component.html',
  styleUrls: ['./pie-charts.component.scss']
})
export class PieChartsComponent implements OnInit {
  public dataSource: Object;
  public chart: any;
  @Input() chartData = { type: 'pie2d' };
  constructor() {
    this.dataSource = {
      chart: {
        caption: '',
        subCaption: '',
        numberPrefix: '',
        showPercentInTooltip: '1',
        decimals: '1',
        useDataPlotColorForLabels: '1',
        theme: 'fusion',
        enableSmartLabels: '0',
        enableRotation: 1,
        enableSlicing: 0,
        slicingDistance: '10',
        pieRadius: 80,
        labelDistance: '3',
        skipOverlapLabels: '1',
        showValues: '1',
        showLabels: '1',
        showPlotBorder: '1',
        plotBorderThickness: '3',
        plotBorderColor: '#dddddd'
      },
      data: []
    }; // end of this.dataSource
  }

  ngOnInit() {
  }

  initialized($event) {
    this.chart = $event.chart; // Storing the chart instance
    this.updateChart(this.chartData);
  }

  updateChart(data) {
    if (this.chart) {
      // this.dataSource['chart']['caption'] = data.caption;
      if (data.genConfig) {
        const config = Object.keys(data.genConfig);
        config.forEach((val, key) => {
          this.dataSource['chart'][val] = data.genConfig[val];
        });
      }
      this.dataSource['data'] = data.data;
      this.chart.setJSONData(this.dataSource);
    }
  }

}
